const STORAGE_KEY = "rqExchangeLog";
const MODE_KEY = "rqExchangeWindow";
const CHANGE = "rq-exchange-log";
const LIMIT = 200;

export type RqExchange = {
  id: string;
  at: string;
  url: string;
  status: number | null;
  requestHeadersText: string;
  requestPayloadText: string;
  responseHeadersText: string;
  responsePayloadText: string;
};

export type RqWindowMode = "closed" | "open" | "minimized";
export type RqExchangePart = "outHeaders" | "outPayload" | "inHeaders" | "inPayload";

export function exactJsonText(value: unknown): string {
  if (typeof value === "string") return value;
  if (value == null) return "";
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function readList(): RqExchange[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeList(items: RqExchange[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, LIMIT)));
  window.dispatchEvent(new CustomEvent(CHANGE));
}

export function listRqExchanges(): RqExchange[] {
  return readList();
}

export function recordRqExchange(input: {
  url?: string;
  status?: number | null;
  requestHeaders?: unknown;
  request?: unknown;
  responseHeaders?: unknown;
  response?: unknown;
}) {
  const item: RqExchange = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    at: new Date().toISOString(),
    url: String(input.url || ""),
    status: input.status == null || Number.isNaN(Number(input.status)) ? null : Number(input.status),
    requestHeadersText: exactJsonText(input.requestHeaders),
    requestPayloadText: exactJsonText(input.request),
    responseHeadersText: exactJsonText(input.responseHeaders),
    responsePayloadText: exactJsonText(input.response),
  };
  writeList([item, ...readList()]);
  writeRqWindowMode("open");
  return item.responsePayloadText;
}

export function deleteRqExchange(id: string) {
  writeList(readList().filter((item) => item.id !== id));
}

export function readRqWindowMode(): RqWindowMode {
  const value = localStorage.getItem(MODE_KEY);
  if (value === "open" || value === "minimized") return value;
  return "closed";
}

export function writeRqWindowMode(mode: RqWindowMode) {
  localStorage.setItem(MODE_KEY, mode);
  window.dispatchEvent(new CustomEvent(CHANGE));
}

export function onRqExchangeChange(listener: () => void) {
  window.addEventListener(CHANGE, listener);
  return () => window.removeEventListener(CHANGE, listener);
}

function exchangeBody(item: RqExchange) {
  try {
    let parsed = JSON.parse(item.responsePayloadText || "");
    if (typeof parsed === "string") parsed = JSON.parse(parsed);
    return parsed;
  } catch {
    return null;
  }
}

function correctReturn(body: any) {
  const source = body?.rqResponse || body;
  const actu = source?.retourTrans?.retourTransActu || source?.retourTransActu || null;
  const psiNoTrans = String(actu?.psiNoTrans || source?.psiNoTrans || "").trim();
  const errors = [
    source?.retourTrans?.listErr,
    actu?.listErr,
    source?.retourTrans?.retourTransLot?.listErr,
    source?.listErr,
  ];
  if (!psiNoTrans || errors.some((list) => Array.isArray(list) && list.length > 0)) return false;
  return true;
}

export function kitchenExchangeMark(noTrans: string, sinceMs = 0): "ok" | "" {
  const needle = String(noTrans || "").trim();
  const recent = readList().filter((item) => !sinceMs || Date.parse(item.at) >= sinceMs - 2000);
  const matched = needle
    ? recent.filter((item) => `${item.requestPayloadText || ""}${item.responsePayloadText || ""}`.includes(needle))
    : recent;
  const rows = matched.length ? matched : recent;
  return rows.some((item) => correctReturn(exchangeBody(item))) ? "ok" : "";
}
